import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagLS = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M0 25a24.9 24.9 0 0 0 2.48 10.87L25 36.957l22.52-1.087A24.901 24.901 0 0 0 50 25a24.9 24.9 0 0 0-2.48-10.87L25 13.045 2.48 14.13A24.9 24.9 0 0 0 0 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#6DA544",
  d: "M25 50c9.912 0 18.476-5.768 22.52-14.13H2.48C6.525 44.232 15.089 50 25.001 50Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#0052B4",
  d: "M25 0C15.09 0 6.525 5.768 2.481 14.13h45.038C43.476 5.768 34.912 0 25 0Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#000",
  d: "M26.63 24.456v-5.978h-3.26v5.978l-3.94 3.939A6.517 6.517 0 0 0 25 31.522a6.517 6.517 0 0 0 5.569-3.127l-3.939-3.939Z"
}));
FlagLS.displayName = 'FlagLS';
export default withFlagWrapper(FlagLS);
//# sourceMappingURL=index.js.map